import { bool, string } from 'prop-types'
import { type FC } from 'react'

import './Anchor.scss'

type AnchorProps = {
  expander?: boolean
  id: string
  smoothScrolling?: boolean
}

const Anchor: FC<AnchorProps> = ({ expander, id, smoothScrolling }) => (
  <div
    className="a-Anchor"
    data-behavior={smoothScrolling ? 'smooth' : 'auto'}
    data-clientside-hook="anchorContainer"
    data-expander={String(expander)}
  >
    <span data-id={id} className="a-Anchor__inner" />
  </div>
)

Anchor.propTypes = {
  expander: bool,
  id: string.isRequired,
  smoothScrolling: bool,
}

Anchor.defaultProps = {
  expander: false,
  smoothScrolling: false,
}

export default Anchor
